module.exports = __webpack_public_path__ + "img/qzz.94ef888d.jpg";